"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _getDisplayName = _interopRequireDefault(require("./getDisplayName"));

var _default = function _default(fetchAsyncState) {
  return function (WrappedComponent) {
    var FetchContainer = function FetchContainer(props) {
      return _react.default.createElement(WrappedComponent, props);
    };

    FetchContainer.displayName = "WithFetch(".concat((0, _getDisplayName.default)(WrappedComponent), ")");
    FetchContainer.fetchAsyncState = fetchAsyncState;
    return (0, _hoistNonReactStatics.default)(FetchContainer, WrappedComponent);
  };
};

exports.default = _default;